import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'is',
  months: [
    'janúar',
    'febrúar',
    'mars',
    'apríl',
    'maí',
    'júní',
    'júlí',
    'ágúst',
    'september',
    'október',
    'nóvember',
    'desember',
  ],
  monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maí', 'jún.', 'júl.', 'ágú.', 'sep.', 'okt.', 'nóv.', 'des.'],
  weekdays: ['sunnudagur', 'mánudagur', 'þriðjudagur', 'miðvikudagur', 'fimmtudagur', 'föstudagur', 'laugardagur'],
  weekdaysMin: ['S', 'M', 'Þ', 'M', 'F', 'F', 'L'],
  weekdaysShort: ['sun.', 'mán.', 'þri.', 'mið.', 'fim.', 'fös.', 'lau.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D.M.YYYY',
    LL: 'D. MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY, HH:mm',
    'LLL-Y': 'D. MMMM, HH:mm',
    LLLL: 'dddd, D. MMMM YYYY, HH:mm',
    'LLLL-Y': 'dddd D. MMMM, HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M.',
    ll: 'D. MMM YYYY',
    'll-Y': 'D. MMM',
    'll-D': 'MMM YYYY',
    lll: 'D. MMM YYYY, h:mm A',
    'lll-Y': 'D. MMM, h:mm A',
    llll: 'ddd, D. MMM YYYY, h:mm A',
    'llll-Y': 'ddd, D. MMM, h:mm A',
    'll-Y+w': 'ddd, D. MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D. MMMM YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'f.h.', pm: 'e.h.', AM: 'f.h.', PM: 'e.h.' },
  past: {
    y: { one: 'fyrir %s ári', other: 'fyrir %s árum' },
    M: { one: 'fyrir %s mán.', other: 'fyrir %s mán.' },
    w: { one: 'fyrir %s viku', other: 'fyrir %s vikum' },
    d: { one: 'fyrir %s degi', other: 'fyrir %s dögum' },
    h: { one: 'fyrir %s klst.', other: 'fyrir %s klst.' },
    m: { one: 'fyrir %s mín.', other: 'fyrir %s mín.' },
    s: { one: 'fyrir %s sek.', other: 'fyrir %s sek.' },
  },
  future: {
    y: { one: 'eftir %s ár', other: 'eftir %s ár' },
    M: { one: 'eftir %s mán.', other: 'eftir %s mán.' },
    w: { one: 'eftir %s viku', other: 'eftir %s vikur' },
    d: { one: 'eftir %s dag', other: 'eftir %s daga' },
    h: { one: 'eftir %s klst.', other: 'eftir %s klst.' },
    m: { one: 'eftir %s mín.', other: 'eftir %s mín.' },
    s: { one: 'eftir %s sek.', other: 'eftir %s sek.' },
  },
  pastLong: {
    y: { one: 'fyrir %s ári', other: 'fyrir %s árum' },
    M: { one: 'fyrir %s mánuði', other: 'fyrir %s mánuðum' },
    w: { one: 'fyrir %s viku', other: 'fyrir %s vikum' },
    d: { one: 'fyrir %s degi', other: 'fyrir %s dögum' },
    h: { one: 'fyrir %s klukkustund', other: 'fyrir %s klukkustundum' },
    m: { one: 'fyrir %s mínútu', other: 'fyrir %s mínútum' },
    s: { one: 'fyrir %s sekúndu', other: 'fyrir %s sekúndum' },
  },
  futureLong: {
    y: { one: 'eftir %s ár', other: 'eftir %s ár' },
    M: { one: 'eftir %s mánuð', other: 'eftir %s mánuði' },
    w: { one: 'eftir %s viku', other: 'eftir %s vikur' },
    d: { one: 'eftir %s dag', other: 'eftir %s daga' },
    h: { one: 'eftir %s klukkustund', other: 'eftir %s klukkustundir' },
    m: { one: 'eftir %s mínútu', other: 'eftir %s mínútur' },
    s: { one: 'eftir %s sekúndu', other: 'eftir %s sekúndur' },
  },
  abbr: {
    y: { one: '%s ár', other: '%s ár' },
    M: { one: '%s mán.', other: '%s mán.' },
    w: { one: '%s vika', other: '%s vikur' },
    d: { one: '%s dagur', other: '%s dagar' },
    h: { one: '%s klst.', other: '%s klst.' },
    m: { one: '%s mín.', other: '%s mín.' },
    s: { one: '%s sek.', other: '%s sek.' },
  },
  full: {
    y: { one: '%s ár', other: '%s ár' },
    M: { one: '%s mánuður', other: '%s mánuðir' },
    w: { one: '%s vika', other: '%s vikur' },
    d: { one: '%s dagur', other: '%s dagar' },
    h: { one: '%s klukkustund', other: '%s klukkustundir' },
    m: { one: '%s mínúta', other: '%s mínútur' },
    s: { one: '%s sekúnda', other: '%s sekúndur' },
  },
  justNow: 'Núna',
  yesterday: 'Í gær',
  today: 'Í dag',
  tomorrow: 'Á morgun',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'h:mm A': 'HH:mm' },
  timeRangeStyles: {
    yl: { start: 'D. MMMM YYYY', end: 'D. MMMM YYYY' },
    'yl-1': { start: 'D. MMMM', end: 'D. MMMM YYYY' },
    ml: { start: 'D. MMMM', end: 'D. MMMM' },
    'ml-1': { start: 'D.', end: 'D. MMMM YYYY' },
    dl: { start: 'D.', end: 'D. MMMM' },
    y: { start: 'D. MMM YYYY', end: 'D. MMM YYYY' },
    'y-1': { start: 'D. MMM', end: 'D. MMM YYYY' },
    m: { start: 'D. MMM', end: 'D. MMM' },
    'm-1': { start: 'D.', end: 'D. MMM YYYY' },
    d: { start: 'D.', end: 'D. MMM' },
    Y: { start: 'ddd, D. MMM YYYY', end: 'ddd, D. MMM YYYY' },
    'Y-1': { start: 'ddd, D. MMM', end: 'ddd, D. MMM YYYY' },
    M: { start: 'ddd, D. MMM', end: 'ddd, D. MMM' },
    D: { start: 'ddd, D. MMM', end: 'ddd, D. MMM' },
    yt: { start: 'D. MMM YYYY, HH:mm', end: 'D. MMM YYYY, HH:mm' },
    mt: { start: 'D. MMM, HH:mm', end: 'D. MMM, HH:mm' },
    dt: { start: 'D. MMM, HH:mm', end: 'D. MMM, HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D. MMM YYYY, HH:mm', end: 'D. MMM YYYY, HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D. MMM, HH:mm', end: 'D. MMM, HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D. MMM, HH:mm', end: 'D. MMM, HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'is';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'f.h.' : 'f.h.';
    } else {
      return isLowerCase ? 'e.h.' : 'e.h.';
    }
  },
};
